import React, { useEffect } from 'react'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { Outlet, useLocation } from 'react-router-dom'
import { DesktopRuntimeStatus } from '@/components/Desktop/DesktopRuntimeStatus'

const APP_ROUTE_TITLES: Array<[string, string]> = [
  ['/app/operations', 'Work in motion'],
  ['/app/website-visitors', 'Website Visitors'],
  ['/app/conversation/calls', 'Call Library'],
  ['/app/economic-additionality', 'Economic Additionality'],
  ['/app/prospects', 'Prospects'],
  ['/app/campaigns', 'Campaigns'],
  ['/app/calendar', 'Calendar'],
  ['/app/discovery', 'Discovery'],
  ['/app/knowledge', 'Sources'],
  ['/app/accounts', 'Accounts'],
  ['/app/outreach', 'Outreach'],
  ['/app/settings', 'Settings'],
  ['/app/ads', 'Ads Dashboard'],
  ['/app/query', 'Ask Ricald'],
  ['/app/inbox', 'Inbox'],
  ['/app/deals', 'Pipeline'],
  ['/app/dashboard', 'Today'],
]

const titleForAppPath = (pathname: string) =>
  APP_ROUTE_TITLES.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`))?.[1]
  || 'Workspace'

export const DashboardPage: React.FC = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = `${titleForAppPath(pathname)} — Ricald`
  }, [pathname])

  return (
    <div className="flex" style={{ minHeight: '100vh', background: 'var(--bg-canvas)' }}>
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <DesktopRuntimeStatus />
        <main
          className="mx-auto w-full page-enter"
          style={{ maxWidth: 1200, padding: 'var(--space-24) var(--space-24) var(--space-80)' }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default DashboardPage
